var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n            Прочитал\n          ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "tapes-order-form",
          attrs: { action: "#", id: "formNew", "lazy-validation": "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 my-0" },
            [
              _vm._t("description", function () {
                return [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg  p-0" }, [
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12 " }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            rules: [_vm.rules.required, _vm.rules.name],
                            required: "",
                            id: "name",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  ФИО *\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.name,
                            callback: function ($$v) {
                              _vm.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12 col-md-6 " }, [
                    _c(
                      "div",
                      {
                        staticClass: "tapes-order-form__item position-relative",
                      },
                      [
                        _c("v-text-field", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "# ### ###-##-##",
                              expression: "'# ### ###-##-##'",
                            },
                          ],
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            id: "tel",
                            oninput:
                              "this.value = this.value.replace(/^\\(8/, '(');",
                            required: "",
                            rules: [_vm.rules.required],
                            max: "20",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Телефон *\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.tel,
                            callback: function ($$v) {
                              _vm.tel = $$v
                            },
                            expression: "tel",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 " }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            rules: [_vm.rules.mail],
                            oninput: "this.value = this.value.trim()",
                            id: "email",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Электронная почта\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.email,
                            callback: function ($$v) {
                              _vm.email = $$v
                            },
                            expression: "email",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-select", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            items: _vm.width,
                            label: "Ширина, мм",
                            "append-icon": "mdi mdi-chevron-down",
                            id: "width",
                            "menu-props": { contentClass: "wrapp_cooperation" },
                          },
                          model: {
                            value: _vm.selectedWidth,
                            callback: function ($$v) {
                              _vm.selectedWidth = $$v
                            },
                            expression: "selectedWidth",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-select", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            items: _vm.length,
                            label: "Длина, м",
                            required: "",
                            "append-icon": "mdi mdi-chevron-down",
                            id: "height",
                            "menu-props": { contentClass: "wrapp_cooperation" },
                          },
                          model: {
                            value: _vm.selectedLength,
                            callback: function ($$v) {
                              _vm.selectedLength = $$v
                            },
                            expression: "selectedLength",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-select", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            items: _vm.thickness,
                            label: "Толщина, мкм",
                            required: "",
                            "append-icon": "mdi mdi-chevron-down",
                            id: "thickness",
                            "menu-props": { contentClass: "wrapp_cooperation" },
                          },
                          model: {
                            value: _vm.selectedThickness,
                            callback: function ($$v) {
                              _vm.selectedThickness = $$v
                            },
                            expression: "selectedThickness",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mx-0 my-0" }, [
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-select", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            items: _vm.color,
                            label: "Цвет фона",
                            "append-icon": "mdi mdi-chevron-down",
                            id: "color",
                            "menu-props": { contentClass: "wrapp_cooperation" },
                          },
                          model: {
                            value: _vm.selectedColor,
                            callback: function ($$v) {
                              _vm.selectedColor = $$v
                            },
                            expression: "selectedColor",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-select", {
                          staticClass: "tapes-order-form__input",
                          attrs: {
                            items: _vm.colorAmount,
                            label: "Кол-во цветов печати",
                            "append-icon": "mdi mdi-chevron-down",
                            id: "colorAmount",
                            "menu-props": { contentClass: "wrapp_cooperation" },
                          },
                          model: {
                            value: _vm.selectedColorAmount,
                            callback: function ($$v) {
                              _vm.selectedColorAmount = $$v
                            },
                            expression: "selectedColorAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12  col-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "tapes-order-form__item" },
                      [
                        _c("v-text-field", {
                          staticClass: "tapes-order-form__input",
                          attrs: { id: "printing" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                  Тираж, рулонов\n\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.printing,
                            callback: function ($$v) {
                              _vm.printing = $$v
                            },
                            expression: "printing",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-12 " }, [
                  _c("div", { staticClass: "tapes-order-form__item " }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "summary p-12 bg-gray-100 border border-gray-300 drag_form d-flex flex-column justify-content-center",
                        attrs: { id: "summary" },
                        on: {
                          dragover: _vm.dragover,
                          dragleave: _vm.dragleave,
                          drop: _vm.drop,
                        },
                      },
                      [
                        _c("input", {
                          ref: "file",
                          staticClass:
                            "w-px h-px opacity-0 overflow-hidden absolute",
                          attrs: {
                            type: "file",
                            multiple: "",
                            name: "fields[assetsFieldHandle][]",
                            id: "assetsFieldHandle",
                            accept:
                              ".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx",
                          },
                          on: { change: _vm.onChange },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "block cursor-pointer",
                            attrs: { for: "assetsFieldHandle" },
                          },
                          [
                            _c("div", [
                              _vm._v(
                                "\n                  Загрузить макет (Перетащите файлы сюда или нажмите, чтобы загрузить)\n                "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        this.filelist.length
                          ? _c(
                              "ul",
                              { staticClass: "mt-4" },
                              _vm._l(_vm.filelist, function (file, index) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass: "text-sm p-1 text-left",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(file.name) +
                                        "\n                  "
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "ml-2 remove_file",
                                        attrs: {
                                          type: "button",
                                          title: "Remove file",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.remove(
                                              _vm.filelist.indexOf(file)
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Удалить\n                  "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" }, [
                  _c("div", {
                    staticClass: "w-100 mt-30",
                    class: _vm.captchaPassed ? "" : "error-captcha",
                    attrs: { id: "captcha-container" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-30" },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          rules: [
                            function (v) {
                              return !!v || "Это обязательный пункт"
                            },
                          ],
                          required: "",
                          color: "red",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "customLabelForm" }, [
                                  _vm._v(
                                    "\n                  Я выражаю согласие с "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "javascript:void(0);",
                                        target: "_blank",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$refs.modal_contents_agree.modal_open(
                                            "scroll_false"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "условиями\n                  использования"
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " моих персональных данных для обработки данного обращения ООО\n                  «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область, г.\n                  Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю\n                  согласие с\n                  "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "position-relative zi-1",
                                      attrs: { href: _vm.policy },
                                      on: {
                                        click: function ($event) {
                                          return _vm.linkOpen(_vm.policy)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Политикой\n                    конфиденциальности"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" и "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "position-relative zi-1",
                                      attrs: { href: _vm.agreement },
                                      on: {
                                        click: function ($event) {
                                          return _vm.linkOpen(_vm.agreement)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Пользовательским\n                  соглашением."
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: { color: "red" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "customLabelForm" }, [
                                  _vm._v(
                                    "\n                  Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                  предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,\n                  Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и\n                  партнеров.\n                "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.consentToInform,
                          callback: function ($$v) {
                            _vm.consentToInform = $$v
                          },
                          expression: "consentToInform",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn_form teeestt  d-flex align-items-center justify-content-start ",
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: " btn-red w-mc",
                              attrs: { disabled: !_vm.valid, type: "submit" },
                              on: { click: _vm.sendForm },
                            },
                            [
                              _vm._v(
                                "\n                Отправить\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }